import SatelliteImage from '../assets/images/satellite-image.png';
import PoolDetector from '../assets/images/pool-detector.png';

export const Solution = () => {
  return (
    <section id='solution' className='bd-container'>
      <div className='section-container'>
        <h1>Nos solutions</h1>
        <p>Grâce à nos outils d’intelligence artificielle, on peut faire: la détection, l'extraction ainsi que la
          mesure d’objet sur ortophoto et image satellitaire.
        </p>
        <div className='image_center'>
          <img src={SatelliteImage} alt='Bridge Logo' style={{ objectFit: 'contain', maxWidth: '60%' }} />
        </div>
        <p>Détection de bâtis dans les villes, maison, toits, jardin, extension de surface habitable, installations
          énergétiques, que vous soyez responsable SIG, gestionnaires immobiliers ou professionnel du bâti BPartners
          vous accompagne pour analyser vos objets d’intérêts.
        </p>
        <p>Grâce à notre plateforme souveraine, et nos outils d’annotations, vous renseignez l’objet d’intérêt de
          votre choix et notre IA detector vous fait un rapport détaillé.
        </p>
        <div className='image_center'>
          <img src={PoolDetector} alt='Bridge Logo' style={{ objectFit: 'contain', maxWidth: '60%' }} />
        </div>
      </div>
    </section>
  );
};